import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { closeSessionSuccessful, closeSessionFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* closeSession(action) {
  try {
    const url = `${BACKEND_URL}/sessions/${action.payload?.id}/finish`;
    const dataResponse = yield makeRequest(url, action.payload?.pool, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      const data = yield getBodyJson(dataResponse);
      yield put(closeSessionSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(closeSessionFailed(data));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(closeSessionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
